import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment as ENV } from '../../environments/environment';

import { PersonMainDataItem, StudentEventItem, SkillDetailItem } from '../models/SaidEvent';

/**
 * SAID event service
 */
@Injectable({ providedIn: "root" })
export class SaidEventService {
    constructor(public http: HttpClient) { }

	public get apiUrl(): string { return `${ENV.apiUrl}/saidEvents` }

	get(studentId: string): Observable<StudentEventItem[]> {
        return this.http.get<StudentEventItem[]>(this.apiUrl, {
			params: {
				studentId
			}
        });
	}

    getPersonMainData(email?: string): Observable<PersonMainDataItem[]> {
        return this.http.get<PersonMainDataItem[]>(`${this.apiUrl}/personMainData`, {
            params: {
                email: email
            }
        });
    }

    register(studentId: string, eventId: number): Observable<any> {
        return this.http.post(`${this.apiUrl}/register`, {
            studentId,
            eventId
        });
	}

	unregister(studentId: string, eventId: number): Observable<any> {
        return this.http.post(`${this.apiUrl}/unregister`, {
            studentId,
            eventId
        });
    }

	getSkill(skillId: string): Observable<SkillDetailItem[]> {
        return this.http.get<SkillDetailItem[]>(`${this.apiUrl}/skills/${skillId}`);
    }
}
